import { c } from '../../../utils/tailwind-merge';
import { LinkV2 } from '../../atoms/Link/Link.v2';
import {
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../../molecules/Table/Table';
import { PublisherInfoTableProps } from './PublisherInfoTable.types';

export const PublisherInfoTable = ({
  supportContact,
  website,
  organizationName,
  publisherProfile,
  address,
  country,
  // reviews,
  microcopy,
  className = '',
  rightColumnTextAlign = 'right',
}: PublisherInfoTableProps) => {
  // const hasReviews = reviews && reviews?.value > 0;

  return (
    <Table className={c('w-full !table-fixed', className)}>
      <colgroup>
        <col className="sm:w-[280px] w-[170px] md:w-[190px]" />
        <col className="w-auto" />
      </colgroup>

      {microcopy.title && <TableCaption>{microcopy.title}</TableCaption>}

      <TableHeader className="sr-only">
        <TableRow>
          <TableHead>{microcopy.headerColumn1}</TableHead>
          <TableHead>{microcopy.headerColumn2}</TableHead>
        </TableRow>
      </TableHeader>

      <TableBody
        className="[&>tr>td:first-child]:whitespace-normal [&>tr>td:first-child]:break-words [&>tr>td]:py-1.5"
        rightColTextAlign={rightColumnTextAlign}
      >
        {/* TODO: Add this when data from Publisher is being returned */}
        {/*           {hasReviews && microcopy.reviews && microcopy.reviewsAriaLabel && (
            <TableRow>
              <TableHead scope="row" className="pr-1">
                {microcopy.reviews}
              </TableHead>
              <TableCell>
                <div className="[&_span]:!inline [&_span]:!cursor-default [&_span]:!font-normal [&_span]:!text-grey-900 [&_span]:!no-underline [&_span]:hover:!text-grey-900 [&_span]:hover:!no-underline">
                  {microcopy.reviewsAriaLabel && (
                    <ReviewStars
                      className="inline-flex"
                      value={reviews.value}
                      max={reviews.max}
                      reviews={5}
                      microcopy={{
                        ariaLabel: microcopy.reviewsAriaLabel,
                      }}
                      showReviewsLink={false}
                      variant="small"
                    />
                  )}
                </div>
              </TableCell>
            </TableRow>
          )} */}

        {supportContact && microcopy.supportContact && (
          <TableRow>
            <TableHead scope="row" className="pr-1">
              {microcopy.supportContact}
            </TableHead>
            <TableCell>{supportContact}</TableCell>
          </TableRow>
        )}

        {website && (
          <TableRow>
            <TableHead scope="row" className="pr-1">
              {microcopy.website}
            </TableHead>
            <TableCell>
              <LinkV2
                size="small"
                openInANewTab
                href={website}
                aria-label={`${microcopy.website}: ${website}`}
              >
                {website}
              </LinkV2>
            </TableCell>
          </TableRow>
        )}

        {organizationName && microcopy.verifiedOrganizationName && (
          <TableRow className="align-top">
            <TableHead scope="row" className="pr-1">
              <div className="block whitespace-normal break-words leading-snug [word-break:normal]">
                {microcopy.verifiedOrganizationName}
              </div>
            </TableHead>

            <TableCell className="align-top">{organizationName}</TableCell>
          </TableRow>
        )}

        {publisherProfile && microcopy.publisherDetails && (
          <TableRow>
            <TableHead scope="row" className="pr-1">
              {microcopy.publisherDetails}
            </TableHead>
            <TableCell className="[&_a]:no-underline [&_span]:no-underline">
              <LinkV2
                size="small"
                href={publisherProfile}
                aria-label={`${microcopy.publisherDetails}: ${microcopy.viewPublisherDetails}`}
              >
                {microcopy.viewPublisherDetails}
              </LinkV2>
            </TableCell>
          </TableRow>
        )}

        {address && microcopy.address && (
          <TableRow>
            <TableHead scope="row" className="pr-1 !align-top">
              {microcopy.address}
            </TableHead>
            <TableCell className="space-y-1">
              {address.name && <div>{address.name}</div>}
              {address.city}
              {address.state && `, ${address.state}`}
              {address.country && <div>{address.country}</div>}
            </TableCell>
          </TableRow>
        )}

        {country && microcopy.country && (
          <TableRow>
            <TableHead scope="row" className="pr-1">
              {microcopy.country}
            </TableHead>
            <TableCell>{country}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};
